import { IsTypingProps } from './types/props-types';
import { getRandomMessage } from './utils/initial-messages';

export default function IsTyping({ isTyping }: IsTypingProps) {
	return (
		<div className={isTyping ? 'min-h-[20px]' : 'hide'}>
			<p>
				<i>{isTyping && getRandomMessage()}</i>
			</p>
		</div>
	);
}
